import { render, staticRenderFns } from "./events-organization.vue?vue&type=template&id=7fc97c1e&"
import script from "./events-organization.vue?vue&type=script&lang=js&"
export * from "./events-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports